<template>
    <div id="OrderDenominationalFormComponent">
        <button ref="btnClearOrderLocal" @click="clearOrderLocal" v-show="false"></button>
        <button ref="btnSaveOrderLocal" @click="saveOrderLocal" v-show="false"></button>
        <button ref="btnSetDataJumpSeller" @click="setDataJumpSeller" v-show="false"></button>
        <nav class="navbar navbar-light bg-light mb-2">
            <div class="form-inline">
                Order de Pedido -
                <span v-if="idLocal == 0" class="badge badge-primary">
                    Nuevo
                </span>
                <span v-else>
                    Nº {{ idLocal }}
                </span>
                <div class="float-right d-none d-sm-inline separator"></div>
                <span>
                    TOTAL:
                    <b>{{ methodFormatNumber(totalOrder) }}</b>
                </span>
            </div>
            <div class="form-inline">
                <button type="button" class="btn btn-sm mr-1" title="Limpiar" @click="clearOrderLocal"><i
                        class="fas fa-broom text-secondary"></i></button>
                <img src="/img/a.png" width="20px" class="pointer" data-toggle="modal" title="Pedidos WEB"
                    data-target="#jumpSellerOrdersModal" ref="btnShowJumpSellerOrdersModal"
                    @click="showJumpSellerOrdersModal">
                <div class="float-right d-none d-sm-inline separator"></div>
                <button type="button" class="btn btn-sm mr-1" title="Pago"><i
                        class="fas fa-cash-register text-info"></i></button>
                <button type="button" class="btn btn-sm " @click="saveOrderLocal" :disabled="disabledBtnSave"
                    title="Guardar"><i class="fas fa-save text-primary"></i></button>
                <div class="float-right d-none d-sm-inline separator"></div>
                <button type="button" class="btn btn-sm" title="Ir al listado de pedidos" @click="closeComponent"><i
                        class="fas fa-list"></i></button>
            </div>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-7 border">
                    <div class="row mt-1">
                        <div class="col-7">
                            <div class="input-group">
                                <label v-show="false" for="searchProductList" ref="searchProductList"></label>
                                <input type="text" class="form-control form-control-sm"
                                    placeholder="Ingrese producto o cantidad" id="searchProductList"
                                    v-model="searchProducts" @keyup.enter="analyzeSearchLocal(searchProducts)"
                                    @focus="$event.target.select()" :readonly="readonlySearchProducts"
                                    :title="(priceListIdSelected > 0) ? 'Ingrese producto o cantidad' : 'Seleccione una lista de precios antes'">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary btn-sm">x {{ quatityProduct }}</button>
                                    <button class="btn btn-outline-secondary btn-sm" type="button">
                                        <i v-if="!searchingProduct" class="fas fa-search"></i>
                                        <img v-else src="@/assets/search-color.gif" width="20px" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <select class="form-control form-control-sm" v-model="priceListIdSelected"
                                :disabled="searchingPriceList" @change="clearOrderProduct">
                                <option v-if="searchingPriceList == true" disabled selected value="0">Buscando listas de
                                    precios . . . </option>
                                <option v-if="listPriceLists.length == 0 && searchingPriceList == false" value="-1"
                                    disabled selected>No hay listas de precios para seleccionar</option>
                                <option v-if="listPriceLists.length > 0 && searchingPriceList == false" value="0"
                                    disabled selected>Seleccione una lista de Precios</option>
                                <option v-for="(item, index) in listPriceLists" :key="index" :value="item.id">{{
            item.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div style="height: 450px; max-height:450px; overflow-x:auto">
                        <table class="table table-sm table-12">
                            <thead>
                                <tr>
                                    <th style="width:15px">#</th>
                                    <th>Producto</th>
                                    <th class="text-center" style="width:80px">Cantidad</th>
                                    <th class="text-right" style="width:80px">Precio</th>
                                    <th class="text-right" style="width:80px">Total</th>
                                    <th style="width:20px"><i class="fas fa-broom pointer"
                                            @click="clearOrderProduct"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in objectOrder.order_products" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <div>{{ item.product.name }}</div>
                                        <small>Cod: {{ item.product.id }}</small>
                                        <small>- ISBN: {{ item.product.isbn }}</small>
                                    </td>
                                    <td class="text-center">
                                        <input v-model="item.quantity" type="text" class="text-center"
                                            style="width: 50px" @focus="$event.target.select()"
                                            @blur="setPriceOrderProducts(item)"
                                            @keyup.enter="enterOrderProductQuantity(item)" />
                                    </td>
                                    <td class="text-right">
                                        <input v-model="item.price" type="text" class="text-right" style="width: 50px"
                                            :class="(item.price != item.original_price) ? 'text-warning' : ''"
                                            @focus="$event.target.select()"
                                            :title="(item.price != item.original_price) ? 'El precio Original es de ' + methodFormatNumber(item.original_price) : (changePrice) ? '' : 'No tienes permiso para cambiar el precio'"
                                            :readonly="!changePrice">
                                    </td>
                                    <td class="text-right">{{ methodFormatNumber(item.price * item.quantity) }}</td>
                                    <td class="text-right">
                                        <i class="far fa-trash-alt text-danger pointer"
                                            :title="'Quitar ' + item.product.name"
                                            @click="removeOrderProductLocal(item)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr>
                    <div class="mr-3">
                        <table style="width:100%">
                            <tbody>
                                <tr>
                                    <td>{{ objectOrder.order_products.length }} titulo{{
            (objectOrder.order_products.length == 1) ? '' : 's' }}</td>
                                    <td colspan="2" class="text-right"><label>Sub Total</label></td>
                                    <td class="text-right" style="width:80px">{{ methodFormatNumber(subTotalOrder) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right"><label for="inputShippingPrice"
                                            ref="labelShippingPrice">Flete</label></td>
                                    <td class="text-right">
                                        <input type="text" id="inputShippingPrice" ref="inputShippingPrice"
                                            class="text-right" style="font-weight: bold; width:70px;"
                                            v-model="objectOrder.shipping_price" v-if="shippingPrice"
                                            @blur="shippingPrice = false" @focus="$event.target.select()"
                                            @keyup.enter="shippingPrice = false" />
                                        <span v-else @click="focusShippingPrice()"
                                            style="font-weight: bold; width:70px;">{{
            methodFormatNumber(objectOrder.shipping_price) }}</span>
                                    </td>
                                </tr>
                                <tr style="font-size: 16px">
                                    <td colspan="3" class="text-right"><label>TOTAL</label></td>
                                    <td class="text-right"><b>{{ methodFormatNumber(totalOrder) }}</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right"><label>Pagado</label></td>
                                    <td class="text-right">{{ methodFormatNumber(totalOrderPayment) }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right"><label>Vuelto</label></td>
                                    <td class="text-right">{{ methodFormatNumber(totalOrderPayment - totalOrder) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-5">
                    <div v-show="optionTabs == 'DATA-CLIENT'">
                        <div v-if="isWeb">
                            <div class="alert alert-info" role="alert">
                                Está tomando el pedido WEB Nº
                                <a :href="'https://editorial-aces-chile.jumpseller.com/admin/cl/orders/edit/' + orderWebLocal.id"
                                    target="_blank" style="color: #333">
                                    {{ orderWebLocal.id }}
                                </a>
                                que está
                                <span class="badge" :class="classJumpsellerOrderStatus(orderWebLocal.status)"
                                    style="padding: 3px 5px;">
                                    {{ spanishJumpsellerOrderStatus(orderWebLocal.status) }}
                                </span>
                                <span>
                                    por un monto de <b>${{ methodFormatNumber(orderWebLocal.total) }}</b>
                                </span>
                                <span v-if="jumsellerOrderLink" class=" float-right">
                                    <context-menu _class="fas fa-exclamation-triangle text-warning"
                                        :title="'El pedido Nº ' + orderDefault.id + ' está vinculado a este pedido WEB'"
                                        :list="[{ text: 'Ver', value: orderDefault.id, selected: false }]"
                                        :multiSelect="false" :markSelection="false" :defaultSelected="null"
                                        @actionSelectItem="actionSelectMenuItemPagoLocal" ref="contextMenuOrderDefault"
                                        :saveSelection="false">
                                    </context-menu>
                                </span>
                            </div>
                            <div v-if="searchingJumpsellerLinkClient" class="alert alert-info" role="alert">
                                Buscando si el cliente WEB Nº {{ orderWebLocal.customer.id }} está vinculado a un
                                cliente en el sistema . . . <img src="@/assets/search-color.gif" width="30px" />
                            </div>
                            <div v-if="!searchingJumpsellerLinkClient && !jumsellerCustomerLink"
                                class="alert alert-warning" role="alert">
                                El cliente WEB Nº
                                <a :href="'https://editorial-aces-chile.jumpseller.com/admin/cl/customers/show/' + orderWebLocal.customer.id"
                                    target="_blank" style="color: #333">{{ orderWebLocal.customer.id }}</a>
                                no está vinculado en el sistema
                            </div>
                        </div>

                        <div class="border">
                            <div class="card-body">
                                <div>
                                    <label>Datos Cliente</label>
                                    <autocomplete-input-component ref="autocompleteInputComponentClient"
                                        _class="form-control form-control-sm" :_path="apiBackend + 'clients'"
                                        :_itemDefault="clientDefault" @actionSelectItem="setClientLocal">
                                    </autocomplete-input-component>
                                </div>
                                <div v-if="objectOrder.client != ''">
                                    <label for="listAddress">Direcciones sugeridas</label>
                                    <select id="listAddress" class="form-control form-control-sm"
                                        v-model="addressIDSelected" @change="setAddressSelected">
                                        <option v-if="objectOrder.client.address.length == 0" disabled selected
                                            value="0">No hay domicilios sugeridos</option>
                                        <option v-else disabled selected value="0">Si quiere seleccione uno de estos
                                            domicilios</option>
                                        <option v-for="(item, index) in objectOrder.client.address" :key="index"
                                            :value="item.id">{{ item.street }} - {{ item.comuna }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="border">
                            <div class="card-body">
                                <div>
                                    <label>Datos de envío</label>
                                    <table class="table-12" style="width: 100%">
                                        <tr>
                                            <td>Enviar a</td>
                                            <td>: <input type="text"
                                                    v-model="objectShippingRequest.recipientData.sendto"
                                                    style="width: 95%"></td>
                                        </tr>
                                        <tr>
                                            <td>RUT</td>
                                            <td>: <input type="text"
                                                    v-model="objectShippingRequest.recipientData.number_document"
                                                    style="width: 95%" placeholder="Ingrese el rut aquí"></td>
                                        </tr>
                                        <tr>
                                            <td>Telefono</td>
                                            <td>: <input type="text" v-model="objectShippingRequest.recipientData.phone"
                                                    style="width: 95%"></td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>: <input type="text" v-model="objectShippingRequest.recipientData.email"
                                                    style="width: 95%"></td>
                                        </tr>
                                        <tr>
                                            <td>Dirección</td>
                                            <td>: <input type="text"
                                                    v-model="objectShippingRequest.recipientData.address"
                                                    style="width: 95%"></td>
                                        </tr>
                                        <tr>
                                            <td>Comuna</td>
                                            <td>: <input type="text"
                                                    v-model="objectShippingRequest.recipientData.comuna"
                                                    style="width: 95%"></td>
                                        </tr>
                                        <tr>
                                            <td>Transporte</td>
                                            <td>:
                                                <select v-model="objectShippingRequest.recipientData.transport_id"
                                                    class="margin-right5"
                                                    :style="(objectShippingRequest.recipientData.transport_id == 4) ? 'width: 40%; border:none;' : 'width: 95%; border:none;'">
                                                    <option disabled selected value="0">Seleccione el medio de
                                                        Transporte</option>
                                                    <option v-for="(item, index) in listTransports" :key="index"
                                                        :value="item.id" @click="setRecipientDataTransport(item)">{{
            item.name }}</option>
                                                </select>
                                                <input type="text" style="width: 55%;"
                                                    v-model="objectShippingRequest.recipientData.transport"
                                                    v-show="objectShippingRequest.recipientData.transport_id == 4"
                                                    placeholder="ingrese aquí otro transporte">
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="optionTabs == 'LIST-PRODUCT'">
                        <div class="border">
                            <div class="card-body">
                                <div v-show="!readonlySearchProducts">
                                    <button type="button" class="close" @click="optionTabs = 'DATA-CLIENT'">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <label>Productos Encontrados</label>
                                    <div style="height: 600px; max-height:600px; overflow-x:auto">
                                        <table class="table table-sm table-12 table-hover">
                                            <thead>
                                                <tr></tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in listProducts" :key="index" class="pointer"
                                                    :class="(index == indexSelectedListProduct) ? 'font-weight-bold' : ''"
                                                    @click="indexSelectedListProduct = index"
                                                    @dblclick="selectedProduct(index)">
                                                    <td>
                                                        <img class="img pointer" style="max-height: 50px"
                                                            :src="(item.img == null || item.img == '') ? '/img/img-not-found.png' : item.img"></img>
                                                    </td>
                                                    <td>
                                                        <div>{{ item.name }}</div>
                                                        <small>Cod: {{ item.id }}</small>
                                                        <small>- ISBN: {{ item.isbn }}</small>
                                                    </td>
                                                    <td class="text-right">
                                                        <div v-for="(ite, ind) in item.product_price_list" :key="ind"
                                                            v-if="ite.status == 1" class="text-right">
                                                            <span
                                                                style="width: 100px">{{ methodFormatNumber(ite.quantity) }}
                                                                x </span>
                                                            {{ methodFormatNumber(ite.price) }}
                                                        </div>
                                                        <div v-if="item.product_price_list == 0">
                                                            Sin Precio
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-show="readonlySearchProducts">
                                    <img src="@/assets/search-color.gif" width="32px" />
                                    Buscando articulos que conincidan con <i><b>{{ searchProducts }}</b></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="jumpSellerOrdersModal" tabindex="-1" aria-labelledby="jumpSellerOrdersModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="jumpSellerOrdersModalLabel">Pedidos WEB</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <jumpSeller-list-orders @actionSelectOrder="selectJumpSellerOrderLocal"
                            ref="jumpSellerListOrders"></jumpSeller-list-orders>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"
                            ref="btnCloseJumpSellerOrdersModal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <table class="table">
            <thead>
                <tr>
                    <th>Forma de Pago</th>
                    <th>Monto</th>
                    <th>Banco</th>
                    <th class="text-center">Código</th>
                    <th>Descripción</th>
                    <th class="text-center">Fecha</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in objectOrder.order_payments" :key="index">
                    <td :title="item.type_payment_id">
                        <input type="checkbox" class="form-check-input" :id="'typePaymentCheck' + index"
                            v-model="item.selected" @click="focusAmount(index)">
                        <label class="form-check-label pointer" :for="'typePaymentCheck' + index"
                            @click="focusAmount(index)">{{ item.type_payment.name }}</label>
                    </td>
                    <td><input v-model="item.amount" class="input-default text-right" :disabled="!item.selected"
                            :ref="'amountInput' + index" @focus="$event.target.select()"></td>
                    <td>
                        <select v-if="item.type_payment.listBanks.length > 0" v-model="item.bank_id"
                            :disabled="!item.selected">
                            <option value="null" disabled selected>Banco</option>
                            <option v-for="(ite, inde) in item.type_payment.listBanks" :key="inde" :value="ite.id">{{
            ite.name }}</option>
                        </select>
                    </td>
                    <td><input v-model="item.code" class="input-default text-center" :disabled="!item.selected"
                            @focus="$event.target.select()"></td>
                    <td><input v-model="item.description" class="input-default" :disabled="!item.selected"
                            @focus="$event.target.select()"></td>
                    <td><input type="date" v-model="item.transaction_date" class="input-default text-center"
                            :disabled="!item.selected"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import order from '@/mixins/orders'
import shippingRequest from '@/mixins/shippingsRequest'
import transport from '@/mixins/transports'
import jumpseller from '@/mixins/jumpseller'
import priceList from '@/mixins/generals/priceList.js'
import product from '@/mixins/products'
import payment from '@/mixins/generals/payment.js'
import typePayment from '@/mixins/generals/typePayment.js'

import AutoCompleteInputComponent from '@/components/AutoCompleteInputComponent.vue'
import ContextMenu from '@/components/ContextMenu.vue'
import JumpSellerListOrders from '@/components/JumpSellerListOrders.vue'

export default {
    name: 'OrderDenominationalFormComponent',
    mixins: [mixin, errors, axiosAction, order, shippingRequest, transport, jumpseller, priceList, product, payment, typePayment],
    props: ['id', 'orderWeb'],
    data() {
        return {
            addressIDSelected: 0,
            clientDefault: null,
            jumsellerCustomerLink: false,
            jumsellerOrderLink: false,
            orderDefault: null,
            shippingPrice: false,
            changePrice: false,
            searchProductList: '',
            quatityProduct: 1,
            indexSelectedListProduct: -1,
            orderWebLocal: this.orderWeb,
            optionTabs: 'DATA-CLIENT',
            priceListIDs: []
        }
    },
    components: {
        'autocomplete-input-component': AutoCompleteInputComponent,
        'context-menu': ContextMenu,
        'jumpSeller-list-orders': JumpSellerListOrders,
    },
    computed: {
        disabledBtnSave() {
            if (this.objectOrder.order_products.length == 0)
                return true
            return false
        },
        idLocal() {
            return this.id
        },
        isWeb() {
            if (this.orderWebLocal == null)
                return false
            return true
        },
        inputChangePrice() {
            if (!this.changePrice) {
                alert('No tiene permiso para cambiar el precio')
            }
        },
        readonlySearchProducts() {
            if (this.priceListIdSelected == 0) {
                return true
            }
            if (this.searchingProduct == true) {
                return true
            }
            return false
        },
        subTotalOrder() {
            let total = this.objectOrder.order_products.reduce((a, b) => {
                let c = Math.trunc(Math.abs(b.quantity)) * Math.abs(b.price)
                return a + c
            }, 0);
            return total.toFixed(0)
        },
        totalOrderPayment() {
            let total = 0
            total = this.objectOrder.order_payments.reduce((a, b) => {
                let c = 0
                c = (b.selected) ? Math.abs(b.amount) : c
                return a + c
            }, 0);
            return total.toFixed(0)
        },
        totalOrder() {
            return parseInt(this.subTotalOrder) + parseInt(this.objectOrder.shipping_price)
        }
    },
    methods: {
        initComponentLocal() {
            setTimeout(() => {
                this.getAllTransports()
                this.getAllPriceLists()
                this.getAllTypePayments()
            }, 500)
        },
        addOrderProductsLocal(newOrderProduct) {
            newOrderProduct.price = this.setPriceOrderProducts(newOrderProduct)
            newOrderProduct.original_price = this.setPriceOrderProducts(newOrderProduct)
            this.objectOrder.order_products.push(newOrderProduct)
            this.listProducts = []
        },
        actionSelectMenuItemPagoLocal(item) {
            window.open('/order/' + item.value, "Pedido Nº " + item.value);
        },
        analyzeSearchLocal(search) {
            if (this.priceListIdSelected > 0) {
                if (!this.analyzeSearchGeneral(search)) {
                    alert('que hacemos con esto "' + search + '"')
                }
            } else {
                this.$snotify.info('Debe seleccionar una lista de Precios', 'Atención')
            }
        },
        analyzeSearchGeneralResultNumber(result) {
            this.quatityProduct = result
            this.searchProducts = ''
        },
        analyzeSearchGeneralResultProduct(result) {
            this.quatityProduct = (result.quantity != undefined) ? result.quantity : this.quatityProduct
            this.getAllProductsWithPriceListLocal(result.value, 1)
        },
        analyzeSearchGeneralResultString(result) {
            this.indexSelectedListProduct = -1
            this.getAllProductsWithPriceListLocal(result, 1)
        },
        getAllProductsWithPriceListLocal(search, page = 1) {
            if (this.priceListIdSelected > 0) {
                this.optionTabs = 'LIST-PRODUCT'
                this.getAllProductsWithPriceList(search, this.priceListIdSelected, page)
            }
        },
        clearOrderLocal() {
            this.clientDefault = null,
                this.jumsellerCustomerLink = false
            this.orderDefault = null,
                this.jumsellerOrderLink = false
            this.addressIDSelected = 0
            this.searchProductList = ''
            this.orderWebLocal = null
            this.clearObjectOrder()
            this.clearObjectShippingRequest()
            this.setObjectOrderPayment(this.listTypePayments)
            this.$refs.autocompleteInputComponentClient.$refs.btnClear.click()
        },
        clearOrderProduct() {
            this.objectOrder.order_products = []
        },
        closeComponent() {
            this.clearOrderLocal()
            setTimeout(() => {
                this.$emit('actionCloseComponenet')
            }, 100)
        },
        enterOrderProductQuantity(item) {
            this.setPriceOrderProducts(item)
            this.$refs.searchProductList.click()
        },
        focusAmount(index) {
            if (!this.objectOrder.order_payments[index].selected) {
                if (this.totalOrderPayment == 0 && this.objectOrder.order_payments[index].amount == 0) {
                    this.objectOrder.order_payments[index].amount = this.totalOrder
                } else if (this.totalOrderPayment < this.totalOrder) {
                    this.objectOrder.order_payments[index].amount = this.totalOrder - this.totalOrderPayment
                }
                this.objectOrder.order_payments[index].transaction_date = this.currentDate()
                setTimeout(() => {
                    this.$refs['amountInput' + index][0].focus()
                }, 100)
            } else {
                this.objectOrder.order_payments[index].amount = 0
                this.objectOrder.order_payments[index].bank_id = null
                this.objectOrder.order_payments[index].transaction_date = null
            }
        },
        focusShippingPrice() {
            this.shippingPrice = true
            setTimeout(() => {
                this.$refs.labelShippingPrice.click()
            }, 200)
        },
        getJumpSellerOrdersLocal() {
            this.$emit('actionJumpSellerOrders')
        },
        getAllTypePaymentsResultLocal(response) {
            this.setObjectOrderPayment(response.data.data)
        },
        getAllProductsResultLocal(response) {
            if (response.data.success == true) {
                this.searchProducts = ''
                if (this.listProducts.length == 1) {
                    this.setProductSelected(this.listProducts[0])
                } else if (this.listProducts.length > 1) {
                    this.indexSelectedListProduct = -1
                } else {
                    alert('No encontramos nada')
                }
            } else {
                this.optionTabs = 'DATA-CLIENT'
                alert(response.data.data)
            }
            this.$refs.searchProductList.click()
        },
        getAllTransportsResultLocal(response) { },
        getAllPriceListsResultLocal(response) { },
        removeOrderProductLocal(item) {
            if (this.idLocal == 0) {
                let index = this.objectOrder.order_products.map((el) => parseInt(el.product_id)).indexOf(parseInt(item.product_id))
                if (index > -1) {
                    let orderProductDeleted = this.objectOrder.order_products.splice(index, 1)
                }
            } else {
                if (confirm('¿Desea Eliminar ' + item.product.name + ' definitivamente?')) {

                }
            }
        },
        resetObjectPayment() {
            this.objectOrder.order_payments.foreach(el => {
                el.id = 0
                el.amount = 0
                el.bank_id = null
                el.bank = {}
                el.code = null
                el.description = null
                el.transaction_date = null
                el.status_id = null
                el.status = {}
                el.created_at = null
                el.updated_at = null
            })
        },
        resultAxiosLocal(responseLocal, response) {
            this.$emit('hideLockScreen')
            switch (responseLocal) {
                case 'getAllProductsResult': this.getAllProductsResult(response); break;
                case 'getAllPriceListsResult': this.getAllPriceListsResult(response); break;
                case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
                case 'getAllTypePaymentsResult': this.getAllTypePaymentsResult(response); break;
                case 'showLinkJumpsellerClientResult': this.showLinkJumpsellerClientResult(response); break;
                case 'showLinkJumpsellerOrderResult': this.showLinkJumpsellerOrderResult(response); break;
                default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
            }
        },
        saveOrderLocal() {
            console.log('listo para guardar')
            this.saveOrderResultLocal()
        },
        saveOrderResultLocal(response = {}) {
            this.$emit('actionSaveOrder', response)
        },
        selectedProduct(index) {
            if (index < this.listProducts.length) {
                let ind = this.listProducts[index].product_price_list.map((el) => parseInt(el.status)).indexOf(1)
                this.setProductSelected(this.listProducts[index])
            }
        },
        setAddressSelected() {
            if (this.addressIDSelected > 0) {
                let index = this.objectOrder.client.address.map((el) => parseInt(el.id)).indexOf(parseInt(this.addressIDSelected))
                if (index > -1) {
                    this.objectShippingRequest.recipientData.address = this.objectOrder.client.address[index].street
                    this.objectShippingRequest.recipientData.comuna = this.objectOrder.client.address[index].comuna
                    this.objectShippingRequest.recipientData.transport_id = this.objectOrder.client.address[index].transport_id
                    this.objectShippingRequest.recipientData.transport = this.objectOrder.client.address[index].transport
                }
            }
        },
        setDataJumpSeller() {
            this.objectOrder.order_products = []
            console.log(this.orderWebLocal)
            this.orderWebLocal.products.forEach(product => {
                let code = product.sku.split(' ')
                code = (code.length == 2) ? code[1] : '-1'
                let p = { id: code, name: product.name }
                let op = { exists: 0, id: 0, order_id: 0, product_id: code, product: p, quantity: product.qty, price: parseInt(product.price), original_price: parseInt(product.price) }
                this.addOrderProductsLocal(op)
            });
            this.objectOrder.shipping_price = parseInt(this.orderWebLocal.shipping)
            this.objectShippingRequest.recipientData.sendto = this.orderWebLocal.shipping_address.name + ' ' + this.orderWebLocal.shipping_address.surname
            this.objectShippingRequest.recipientData.address = this.orderWebLocal.shipping_address.address
            this.objectShippingRequest.recipientData.comuna = this.orderWebLocal.shipping_address.municipality
            this.objectShippingRequest.recipientData.phone = this.orderWebLocal.customer.phone
            this.objectShippingRequest.recipientData.email = this.orderWebLocal.customer.email
            this.objectShippingRequest.recipientData.number_document = this.orderWebLocal.billing_address.taxid
            let transport = this.orderWebLocal.shipping_method_name.split(':')
            transport = (transport.length == 1) ? ['Sucursal', 'Retira en ACES'] : transport
            this.objectShippingRequest.recipientData.transport_id = (transport.length == 2) ? this.searchIdTransportsByStr(transport[1].trim()) : '-1'
            this.objectShippingRequest.recipientData.transport = (transport.length == 2) ? transport[1].trim() : ''

            if (this.orderWebLocal.payment_information != null) {
                let payment_information = this.orderWebLocal.payment_information.split(',<br/>')
                if (payment_information[1].split(': ')[1].trim() == 'Transacción aprobada') {
                    let index = this.objectOrder.order_payments.map(el => el.type_payment.syntetic).indexOf(this.orderWebLocal.payment_method_type)
                    if (index > -1) {
                        this.objectOrder.order_payments[index].selected = true
                        this.objectOrder.order_payments[index].amount = this.orderWebLocal.total
                        this.objectOrder.order_payments[index].code = payment_information[5].split(': ')[1].trim()
                        this.objectOrder.order_payments[index].transaction_date = payment_information[3].split(': ')[1].split(' ')[0]
                        this.objectOrder.order_payments[index].description = payment_information[7].split(': ')[1]
                    }
                    console.log(this.objectOrder.order_payments, this.orderWebLocal.payment_method_type, index)
                }
                console.log(payment_information)
                console.log(payment_information[3].split(': ')[1].split(' ')[0], this.currentDate())
            }

            this.showLinkJumpsellerClientLocal(this.orderWebLocal.customer.id)
            this.showLinkJumpsellerOrderLocal(this.orderWebLocal.id)
        },
        setClientLocal(item) {
            this.objectOrder.client_id = item.id
            this.objectOrder.client = item.item
            if (!this.isWeb) {
                this.addressIDSelected = 0
                this.objectShippingRequest.recipientData.sendto = item.item.text
                this.objectShippingRequest.recipientData.phone = item.item.phone
                this.objectShippingRequest.recipientData.email = item.item.email
                this.objectShippingRequest.recipientData.number_document = item.item.number_document
            }
        },
        setPriceOrderProducts(item) {
            let price = item.price
            if (item.product.product_price_list != undefined) {
                let listPrice = item.product.product_price_list.filter((el) => {
                    return (parseInt(el.status) == 1 && parseInt(el.quantity) <= parseInt(item.quantity))
                })
                let qMax = listPrice.reduce((a, b) => {
                    if (b.quantity > a && b.status == 1) {
                        a = parseInt(b.quantity)
                        price = parseInt(b.price)
                    }
                    return a
                }, 0);
                item.price = price
                item.original_price = price
            }
            return price
        },
        setProductSelected(product) {
            this.optionTabs = 'DATA-CLIENT'
            if (product.group.toUpperCase() == 'P') {
                alert('El articulo "' + product.name + ' (cod:' + product.id + ')" es de suscripción, vaya a suscripciones para poder hacer un pedido de suscripcion')
                return false
            }
            if (product.product_price_list.length == 0) {
                alert('El articulo "' + product.name + ' (cod:' + product.id + ')" no tiene precios en esta lista de precios')
                return false
            } else {
                let index = product.product_price_list.map((el) => parseInt(el.status)).indexOf(1)
                if (index == -1) {
                    alert('El articulo "' + product.name + ' (cod:' + product.id + ')" no tiene precios activos en esta lista de precios')
                    return false
                } else {
                    index = this.objectOrder.order_products.map((el) => parseInt(el.product_id)).indexOf(parseInt(product.id))
                    if (index > -1) {
                        this.objectOrder.order_products[index].quantity = parseInt(this.objectOrder.order_products[index].quantity) + parseInt(this.quatityProduct)
                        this.objectOrder.order_products[index].price = this.setPriceOrderProducts(this.objectOrder.order_products[index])
                        this.objectOrder.order_products[index].original_price = this.setPriceOrderProducts(this.objectOrder.order_products[index])
                    } else {
                        let op = {
                            exists: 0,
                            id: 0,
                            order_id: this.idLocal,
                            product_id: product.id,
                            product: product,
                            quantity: this.quatityProduct,
                            price: 0,
                            original_price: 0
                        }
                        this.addOrderProductsLocal(op)
                    }
                    this.quatityProduct = 1
                    return
                }
            }
        },
        selectJumpSellerOrderLocal(item) {
            this.orderWebLocal = item
            this.$refs.btnCloseJumpSellerOrdersModal.click()
            setTimeout(() => {
                this.$refs.btnSetDataJumpSeller.click()
            }, 400)
        },
        setObjectOrderPayment(list) {
            list.forEach(el => {
                this.objectOrder.order_payments.push({ id: 0, type_payment_id: el.id, type_payment: el, amount: 0, bank_id: null, bank: {}, code: null, description: null, transaction_date: null, status_id: null, status: {}, created_at: null, updated_at: null })
            })
        },
        showJumpSellerOrdersModal() {
            this.$refs.jumpSellerListOrders.$refs.btnGetJumpSellerOrders.click()
        },
        showLinkJumpsellerClientLocal(id) {
            this.clientDefault = null
            this.jumsellerCustomerLink = false
            this.showLinkJumpsellerClient(id)
        },
        showLinkJumpsellerClientResultLocal(response) {
            if (response.data.success == true) {
                this.jumsellerCustomerLink = true
                this.clientDefault = response.data.data
                setTimeout(() => {
                    this.$refs.autocompleteInputComponentClient.$refs.btnSetDataDefault.click()
                }, 200)
            } else {
                console.log(response.data.message)
            }
        },
        showLinkJumpsellerOrderLocal(id) {
            this.orderDefault = null
            this.jumsellerOrderLink = false
            this.showLinkJumpsellerOrder(id)
        },
        showLinkJumpsellerOrderResultLocal(response) {
            if (response.data.success == true) {
                this.jumsellerOrderLink = true
                this.orderDefault = response.data.data
                alert('Ya existe un pedido vinculado al pedido WEB Nº ' + this.orderWebLocal.id)
            }
        },
    },
    mounted() {
        this.initComponentLocal()
    }
}
</script>